/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { List, ListItem, Typography } from "@mui/material";
import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  const typeKeys = ["IU", "IC", "SCPU", "STORAGE"];

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("resource_creation.title")}
      </Typography>
      <hr />

      <Typography variant="h3" mt={4} ml={2}>
        {t("resource_creation.resource_info.title")}
      </Typography>

      <Typography variant="h4" mt={4} ml={4}>
        {t("resource_creation.resource_type.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("resource_creation.resource_type.intro")}
        </Box>
      </Typography>

      <Box ml={6}>
        <List component="ul">
          {typeKeys.map((k) => (
            <ListItem key={k} component="li" divider>
              <Typography variant="text" fontSize="1rem" mt={2}>
                <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                  {t(`resource_creation.resource_type.types.${k}.title`)}
                </Typography>{" "}
                {t(`resource_creation.resource_type.types.${k}.desc`)}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Box>

      <Box ml={4} mt={4}>
        <Typography variant="text" fontSize="1rem">
          <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
            {t("resource_creation.note.label")}
          </Typography>{" "}
          {t("resource_creation.note.body")}
        </Typography>
      </Box>

      <Typography variant="h3" mt={4} ml={2}>
        {t("resource_creation.certified_powers.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("resource_creation.certified_powers.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
